module.exports = __webpack_public_path__ + "static/media/UploadIcon.1cedb6e9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-images-upload/UploadIcon.svg
// module id = 1503
// module chunks = 0